export enum AgreementSignByType {
  INSURANCE_HOLDER = 'AGREEMENT_SIGN_BY_TYPE_INSURANCE_HOLDER',
  SUBMITTER = 'AGREEMENT_SIGN_BY_TYPE_SUBMITTER'
}
